// 暗文内容 columns
export const darkTextTableColumns = [
  {
    title: '序号',
    dataIndex: 'index'
  },
  {
    title: '暗文内容',
    dataIndex: 'content'
  },
  {
    title: '适用模块',
    dataIndex: 'module'
  },
  {
    title: '暗文类型',
    dataIndex: 'type'
  },
  {
    title: '操作人',
    dataIndex: 'creator'
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at'
  },
  {
    title: '操作',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  }
]

// 循环暗文 columns
export const loopDarkTextTableColumns = [
  {
    title: '序号',
    dataIndex: 'index'
  },
  {
    title: '暗文内容',
    dataIndex: 'content'
  },
  {
    title: '适用模块',
    dataIndex: 'module'
  },
  {
    title: '暗文类型',
    dataIndex: 'type'
  },
  {
    title: '操作人',
    dataIndex: 'creator'
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

// 热门搜索 columns
export const hotTableColumns = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'center'
  },
  {
    title: '一起学热门搜索内容',
    dataIndex: 'content',
    align: 'center'
  },
  {
    title: '适用模块',
    dataIndex: 'content_type_text',
    align: 'center'
  },
  {
    title: '目标用户',
    dataIndex: 'target_users',
    scopedSlots: { customRender: 'target_users' },
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center'
  },
  {
    title: '操作人',
    dataIndex: 'optioner',
    align: 'center'
  },
  {
    title: '操作时间',
    dataIndex: 'option_time',
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '320px',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
]

// 黑名单 columns
export const blackListTableColumns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index'
  },
  {
    title: '资源ID',
    dataIndex: 'resource_id',
    key: 'resource_id'
  },
  {
    title: '资源名称',
    dataIndex: 'resource_name',
    key: 'resource_name'
  },
  {
    title: '一级品类',
    dataIndex: 'type_one',
    key: 'type_one'
  },
  {
    title: '操作',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  }
]

// 专有名词-草稿库
export const draftColumns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key'
  },
  {
    title: '专有名词',
    dataIndex: 'word',
    key: 'word'
  },
  {
    title: '类别',
    dataIndex: 'category',
    key: 'category',
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '状态',
    dataIndex: 'online_status_text',
    key: 'online_status_text'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    width: '30%',
    scopedSlots: { customRender: 'operation' }
  }
]

export const onlineColumns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    width: '30%'
  },
  {
    title: '专有名词',
    dataIndex: 'word',
    key: 'word',
    width: '30%'
  },
  {
    title: '类别',
    dataIndex: 'category',
    key: 'category',
    width: '30%',
    scopedSlots: { customRender: 'category' }
  }
]

export const keywordsColumns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    align: 'center'
  },
  {
    title: '关键词',
    dataIndex: 'word',
    key: 'word',
    align: 'center'
  },
  {
    title: '一级品类',
    dataIndex: 'first_content_type_name',
    key: 'first_content_type_name',
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'online_status_text',
    key: 'online_status_text',
    align: 'center'
  },
  {
    title: '操作时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    align: 'center'
  },
  {
    title: '操作人',
    dataIndex: 'updator_name',
    key: 'updator_name',
    scopedSlots: { customRender: 'updator_name' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'online_status',
    key: 'online_status',
    scopedSlots: { customRender: 'online_status' },
    align: 'center'
  }
]

export const resourceColumns = [
  {
    title: '关键词',
    dataIndex: 'word',
    key: 'word',
    align: 'center'
  },
  {
    title: '资源ID',
    dataIndex: 'resource_id',
    key: 'resource_id',
    align: 'center'
  },
  {
    title: '资源名称',
    dataIndex: 'resource_name',
    key: 'resource_name',
    align: 'center'
  },
  {
    title: '一级品类',
    dataIndex: 'first_content_type_name',
    key: 'first_content_type_name',
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'online_status_text',
    key: 'online_status_text',
    align: 'center'
  },
  {
    title: '操作时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    align: 'center'
  },
  {
    title: '操作人',
    dataIndex: 'updator_name',
    key: 'updator_name',
    scopedSlots: { customRender: 'updator_name' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'online_status',
    key: 'online_status',
    scopedSlots: { customRender: 'online_status' },
    align: 'center'
  }
]

export const runSettingTableColumns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    align: 'center',
    width: '5%'
  },
  {
    title: '关键词',
    dataIndex: 'key_word',
    key: 'key_word',
    align: 'center',
    width: '10%'
  },
  {
    title: 'URL',
    dataIndex: 'url',
    key: 'url',
    scopedSlots: { customRender: 'url' },
    align: 'center',
    width: '20%'
  },
  {
    title: '状态',
    dataIndex: 'content_status_text',
    key: 'content_status_text',
    align: 'center',
    width: '10%'
  },
  {
    title: '操作人',
    dataIndex: 'optioner',
    key: 'optioner',
    align: 'center',
    width: '20%'
  },
  {
    title: '操作时间',
    dataIndex: 'option_time',
    key: 'option_time',
    align: 'center',
    width: '20%'
  },
  {
    title: '操作',
    dataIndex: 'content_status',
    key: 'content_status',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    width: '40%'
  }
]
